import { usePermissoesOutletContext } from '@/pages/Permissoes'
import { permissoes } from '@/service/api'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

export default function ExcluirPerfilPermissao() {
    const { id } = useParams()
    const { data } = usePermissoesOutletContext()
    const item = data.find(i => i.id === Number(id))
    const { mutateAsync, isLoading } = permissoes.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!item) return null

    function handleSubmit() {
        mutateAsync(Number(id), {
            onSuccess: () => {
                toast.success('Perfil removido com sucesso!')
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            onSubmit={handleSubmit}
            loading={isLoading}
            open={hasPermission(['delete', 'Permissões'])}
        >
            <Dialog.Title>Excluir perfil de permissões</Dialog.Title>
            <Dialog.Content dividers>
                <span>
                    Realmente deseja excluir o perfil de permissões{' '}
                    <strong>{item.nome}</strong>?
                    <br />
                    Essa ação é irreversível.
                </span>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
